import {
  UPDATE_VALID_FORM_DATA,
  UPDATE_VALID_BENEFIT_FORM_DATA,
  UPDATE_FROM_GETDATA,
  ADD_BENEFIT_ITEM,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialClaimData = {
  claimAttributeModel: {
    UpStatus: "",
    ContractClass: "",
    ContractType: "",
    PurchaseDt: "",
    ProductType: "",
    ContractStatus: "",
  },
  claimPADetail: {
    policyNumber: "",
    policyHolderName: "",
    isClaimantPolicyholder: true,
    claimantName: "",
    claimantNricNumber: "",
    claimantEmail: "",
    claimantMobile: "",

    // Testing data
    // policyNumber: "PA001016",
    // policyHolderName: "XIEBIN",
    // isClaimantPolicyholder: true,
    // claimantName: "XIEBIN",
    // claimantNricNumber: "S1405484G",
    // claimantEmail: "XieBin.W@devops.etiqa.com.sg",
    // claimantMobile: "98063015",

    claimAmount: 0,

    declaration: false,
    sourceSystem: "Web",
    planPeriodFrom: "",
    planPeriodTo: "",
  },
  Medical: {
    ME: { MedicalDetailList: [] },
    AM: { MedicalDetailList: [] },
    AMBI: { MedicalDetailList: [] },
    AMID: { MedicalDetailList: [] },
    AMFR: { MedicalDetailList: [] },
    AMCM: { MedicalDetailList: [] },
    AMIM: { MedicalDetailList: [] },
    AMDT: { MedicalDetailList: [] },
    AMSG: { MedicalDetailList: [] },
    AMCIM: { MedicalDetailList: [] },
  },
  Loss: {},
  Other: {},
}

const claimDataReducer = (state = initialClaimData, action) => {
  // const newState = Object.assign({}, state)

  let category = action.category
  let coverage = action.coverage
  let targetModal = action.targetModal
  let targetObjectName = action.targetObjectName

  switch (action.type) {
    case UPDATE_VALID_FORM_DATA:
      return {
        ...state,
        [targetModal]: {
          ...state[targetModal],
          ...action.newData,
        },
      }
    // newState[action.targetModal] = Object.assign(
    //   newState[action.targetModal],
    //   action.newData
    // )
    // return newState

    case UPDATE_VALID_BENEFIT_FORM_DATA:
      return {
        ...state,
        [category]: {
          ...state[category],
          [coverage]: {
            ...state[category][coverage],
            ...action.newData,
          },
        },
      }
    // newState[action.category][action.coverage] = Object.assign(
    //   newState[action.category][action.coverage],
    //   action.newData
    // )
    // return newState

    case UPDATE_FROM_GETDATA:
      let claimPADetailProperty = "claimPADetail"
      return {
        ...state,
        [claimPADetailProperty]: {
          ...state[claimPADetailProperty],
          [targetModal]: action.newData,
        },
      }
    // if (typeof newState["claimPADetail"][action.targetModal] == "undefined") {
    //   newState["claimPADetail"] = {}
    //   newState["claimPADetail"][action.targetModal] = action.newData
    // } else {
    //   newState["claimPADetail"][action.targetModal] = action.newData
    // }
    // return newState

    case ADD_BENEFIT_ITEM:
      return {
        ...state,
        [category]: {
          ...state[category],
          [coverage]: {
            ...state[category][coverage],
            [targetObjectName]: action.newItemList,
          },
        },
      }
    // newState[action.category][action.coverage][action.targetObjectName] =
    //   action.newItemList
    // return newState

    default:
      return state
  }
}

export default claimDataReducer
